// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"IdentityVerificationModal--buttonWrapper--539500","identityVerificationModalBody":"IdentityVerificationModal--identityVerificationModalBody--44d338"};